"use client";

import { useEffect } from "react";

import "../public/fonts/fonts.css";
import "../public/fonts/font-icons.css";
import "../public/css/bootstrap.min.css";
import "../public/css/bootstrap-select.min.css";
import "../public/css/swiper-bundle.min.css";
import "../public/css/animate.css";
import "../public/scss/main.scss";
import "photoswipe/dist/photoswipe.css";
import "rc-slider/assets/index.css";
import "../public/css/admin.css";
import ClientShell from "@/components/layouts/ClientShell";
import { I18nProvider } from "@/context/I18nContext";

export default function RootLayout({ children }) {
	useEffect(() => {
		import("bootstrap/dist/js/bootstrap.esm").catch(() => {});
	}, []);

	return (
		<html lang='ro' dir='ltr'>
			<head>
				<meta name='viewport' content='width=device-width, initial-scale=1, viewport-fit=cover' />

				{/* ── PWA Core ── */}
				<link rel='manifest' href='/manifest.webmanifest' />
				<meta name='application-name' content='Emagyl' />
				<meta name='theme-color' content='#ffffff' />
				<meta name='mobile-web-app-capable' content='yes' />
				<meta name='format-detection' content='telephone=no' />

				{/* ── iOS / Safari ── */}
				<meta name='apple-mobile-web-app-capable' content='yes' />
				<meta name='apple-mobile-web-app-status-bar-style' content='black-translucent' />
				<meta name='apple-mobile-web-app-title' content='Emagyl' />
				<link rel='apple-touch-icon' href='/icons/icon-192x192.png' />

				{/* ── iOS Splash Screens ── */}
				<link
					rel='apple-touch-startup-image'
					href='/splash/iphone5_splash.png'
					media='(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2)'
				/>
				<link
					rel='apple-touch-startup-image'
					href='/splash/iphone6_splash.png'
					media='(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2)'
				/>
				<link
					rel='apple-touch-startup-image'
					href='/splash/iphoneplus_splash.png'
					media='(device-width: 621px) and (device-height: 1104px) and (-webkit-device-pixel-ratio: 3)'
				/>
				<link
					rel='apple-touch-startup-image'
					href='/splash/iphonex_splash.png'
					media='(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3)'
				/>
				<link
					rel='apple-touch-startup-image'
					href='/splash/iphonexr_splash.png'
					media='(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2)'
				/>
				<link
					rel='apple-touch-startup-image'
					href='/splash/iphonexsmax_splash.png'
					media='(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3)'
				/>
				<link
					rel='apple-touch-startup-image'
					href='/splash/ipad_splash.png'
					media='(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2)'
				/>

				{/* ── Microsoft / Windows ── */}
				<meta name='msapplication-TileColor' content='#ffffff' />
				<meta name='msapplication-TileImage' content='/icons/icon-144x144.png' />
				<meta name='msapplication-tap-highlight' content='no' />
			</head>
			<body className='preload-wrapper' dir='ltr'>
				<script
					type='application/ld+json'
					dangerouslySetInnerHTML={{
						__html: JSON.stringify({
							"@context": "https://schema.org",
							"@graph": [
								{
									"@type": "Organization",
									"@id": "https://emagyl.ro/#organization",
									name: "eMagyl.Ro",
									legalName: "EMAGYL S.R.L.",
									url: "https://emagyl.ro",
									logo: "https://emagyl.ro/images/logo/logo-horizontal.webp",
									email: "contact@emagyl.ro",
									telephone: "+40215551309",
									address: {
										"@type": "PostalAddress",
										streetAddress: "Str. Verii, Nr. 38A",
										addressLocality: "Bragadiru",
										addressRegion: "Ilfov",
										postalCode: "077025",
										addressCountry: "RO",
									},
								},
								{
									"@type": "WebSite",
									"@id": "https://emagyl.ro/#website",
									url: "https://emagyl.ro",
									name: "eMagyl.Ro",
									publisher: { "@id": "https://emagyl.ro/#organization" },
									potentialAction: {
										"@type": "SearchAction",
										target: "https://emagyl.ro/?q={search_term_string}",
										"query-input": "required name=search_term_string",
									},
								},
							],
						}),
					}}
				/>
				<I18nProvider>
					<ClientShell>{children}</ClientShell>
				</I18nProvider>
			</body>
		</html>
	);
}
